module.exports = __webpack_public_path__ + "img/hynewtext.59b98c64.png";